export default "__VITE_ASSET__DFawIO1E__"